import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import FirstSection from './FirstSection';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';

export default class SellingPage extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <div className="landing-page">
        <div className="landing-margin">
          <Header onButtonClicked={this.scrollToPrices} />
          <div className="section section-top">
          </div>

          <FirstSection />
          <SecondSection onButtonClicked={this.scrollToPrices}  />
          <ThirdSection onButtonClicked={this.props.onButtonClicked}  />

          <div className="section section-bottom">
          </div>
          <Footer />
        </div>
          <div className="scroll-down"></div>
      </div>
    );
  }

  scrollToPrices(){
      document.getElementById("ThirdSection").scrollIntoView({ block: 'start',  behavior: 'smooth' });
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/index.js